/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StorageResponse
 */
export interface StorageResponse {
    /**
     * 
     * @type {string}
     * @memberof StorageResponse
     */
    value: string | null;
}

export function StorageResponseFromJSON(json: any): StorageResponse {
    return StorageResponseFromJSONTyped(json, false);
}

export function StorageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function StorageResponseToJSON(value?: StorageResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}


